import React, { FC, useCallback, useEffect, useState } from 'react';

import { ROUTES, UNDISTRIBUTES_TIME, MILLISECONDS_DAY } from 'consts';

import { getDataFromLocalStorage } from 'utils';

import { useAppDispatch, useAppSelector, useProfile } from 'hooks';

import { selectUndistributed } from './selectors';

import { getUndistributed } from './slices/globalNotificationSlice';

import { StyledLink, StyledNotification } from './styled';

export const GlobalNotification: FC = () => {
  const [show, setShow] = useState(true);

  const dispatch = useAppDispatch();
  const { isPrimeContractor } = useProfile();
  const undestributed = useAppSelector(selectUndistributed);

  /* eslint-disable */ /* TODO Исправить ошибку ESlint */
  useEffect(
    useCallback(() => {
      const lastTime = getDataFromLocalStorage(UNDISTRIBUTES_TIME);
      const lastRequest = lastTime ? new Date().getTime() - (lastTime as number) : 0;

      if (isPrimeContractor) {
        if (lastRequest >= MILLISECONDS_DAY || !lastRequest) {
          // @ts-ignore TODO TS err
          dispatch(getUndistributed());
          setInterval(() => {
            // @ts-ignore TODO TS err
            dispatch(getUndistributed());
            setShow(true);
          }, MILLISECONDS_DAY);
        } else {
          new Promise(resolve => {
            setTimeout(() => {
              // @ts-ignore TODO TS err
              dispatch(getUndistributed());
              setShow(true);
              resolve(1);
            }, MILLISECONDS_DAY - lastRequest);
          }).then(() => {
            setInterval(() => {
              // @ts-ignore TODO TS err
              dispatch(getUndistributed());
              setShow(true);
            }, MILLISECONDS_DAY);
          });
        }
      }
    }, [dispatch]),
  );
  /* eslint-enable */

  return isPrimeContractor && show && undestributed?.length ? (
    <StyledNotification
      type='error'
      showIcon
      closable
      onClose={() => {
        setShow(false);
      }}
    >
      <>
        {'Есть нераспределенные квартиры на проектах:\n'}
        {undestributed.map(item => (
          <>
            {`${item.name}`}{' '}
            <StyledLink
              to={ROUTES.PLAN.PLACEMENTS + `?project=${item.id}`}
              onClick={() => {
                setShow(false);
              }}
            >
              Перейти
            </StyledLink>
            {' \n'}
          </>
        ))}
      </>
    </StyledNotification>
  ) : (
    <></>
  );
};
